import React from 'react';
import PropTypes from "prop-types";
import editButton from "../../../shared/img/edit-lock-button.svg";
import editButtonInverted from "../../../shared/img/edit-lock-button-inverted.svg";
import addButton from "../../../shared/img/add-widget-button.svg";
import IconButton from "../../../shared/components/others/IconButton";

class WidgetsAreaLockControlArea extends React.Component {
    constructor(props) {
        super(props);
        this.exitFullscreen = this.exitFullscreen.bind(this);
        this.state = {
            onMouseOverText: null,
            fullscreen: false,
            closeFullscreenHelper: null,
            hasPermissionToUpdateDashboard: true,
            dashboard: props.dashboard,
            maxWidgets: false,
            showMaxWidgetsMsg: false,
            alert: {
                show: false
            },
        };
    }

    exitFullscreen() {
        if (this.state.fullscreen) {
            if (!(
                document.fullscreenElement ||
                document.webkitFullscreenElement ||
                document.mozFullScreenElement ||
                document.msFullscreenElement)
            ){
                // this.toggleFullScreen(true);
            }
        }
    }

    render() {
        let {
            fullscreen,
            maxWidgets,
        } = this.state;
        let {
            onEditMode,
            onClick,
            onCreateWidgetClicked,
        } = this.props;

        return (
            <div className="hidden-xs hidden-sm">
                <div className="dashboard-options">
                    <div className="options-buttons">
                        <div className="edit-widgets-area" style={{opacity: (!onEditMode || maxWidgets) ? '0.5' : '1'}}>
                            <IconButton
                                alt="create"
                                selected={false}
                                handleIconClick={onCreateWidgetClicked}
                                image={addButton}
                                disabled={ !onEditMode || maxWidgets}
                            />
                        </div>

                        {fullscreen ? null : <div className="edit-widgets-area pr-4">
                            <IconButton
                                alt="editLock"
                                selected={onEditMode}
                                handleIconClick={onClick}
                                image={editButton}
                                invertedImage={editButtonInverted}
                            />
                        </div>}
                        {/*Not implemented yet*/}
                        {/*<div className="edit-widgets-area" style={{opacity: onEditMode ? '0.5' : '1'}}>*/}
                        {/*     <IconButton*/}
                        {/*         alt="fullscreen"*/}
                        {/*         selected={false}*/}
                        {/*         handleIconClick={onFullScreenClicked}*/}
                        {/*         disabled={onEditMode}*/}
                        {/*         image={fullscreenButton}*/}
                        {/*     />*/}
                        {/*</div>*/}
                    </div>
                    {/*Not implemented yet*/}
                    {/*<div style={{'display': 'inline'}}>*/}
                    {/*    {!fullscreen && <div className="edit-widgets-area-options">*/}
                    {/*        <DashboardSelector*/}
                    {/*            dashboardSelected={{}}*/}
                    {/*            loadEntitiesTree={loadEntitiesTree}*/}
                    {/*            entitiesTree={entitiesTree}*/}
                    {/*        />*/}
                    {/*    </div>}*/}
                    {/*</div>*/}
                </div>
                {/*<div style={{float:"right", display:"block", marginTop: "10px"}}>*/}
                {/*    <span className={"lock-icon-helper-text " + (fullscreen ?  " c-white" : "") }>{onMouseOverText}</span>*/}
                {/*</div>*/}
                {/*{fullscreen ? renderFullScreenHeader() : null}*/}
            </div>
        );
    }
}

WidgetsAreaLockControlArea.propTypes = {
    onClick: PropTypes.func,
    onCreateWidgetClicked: PropTypes.func,
    onFullScreenClicked: PropTypes.func,
    onEditMode: PropTypes.bool,
    loadEntitiesTree: PropTypes.func,
    entitiesTree: PropTypes.object,
};

export default WidgetsAreaLockControlArea;